<script setup lang="ts">
const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
    id: {
        type: String,
        default: () => ({}),
    },
});

const answerRendered = computed(() => {
    return renderRichText(props.blok.answer);
});
</script>

<template>
    <h3 :id="`accordion-flush-heading-${id}`">
        <button
            type="button"
            class="flex justify-between items-center py-5 w-full text-left text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
            :data-accordion-target="`#accordion-flush-body-${id}`"
            aria-expanded="false"
            :aria-controls="`accordion-flush-body-${id}`"
        >
            <span>{{ blok.question }}</span>
            <svg
                data-accordion-icon=""
                class="w-6 h-6 shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                ></path>
            </svg>
        </button>
    </h3>
    <div
        :id="`accordion-flush-body-${id}`"
        class="hidden"
        :aria-labelledby="`accordion-flush-heading-${id}`"
    >
        <div class="py-5 border-b border-gray-200 dark:border-gray-700 format lg:format-lg">
            <ClientOnly>
                <!-- TODO Why is ClientOnly necessary here? -->
                <p class="mb-2 text-gray-500 dark:text-gray-400" v-html="answerRendered"></p
            ></ClientOnly>
        </div>
    </div>
</template>
